import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * CheckboxGroup
 */
export default class CheckboxGroup extends Component {
  static propTypes = {
    prefixCls: PropTypes.string,
    /** 子组件name */
    name: PropTypes.string,
    /** 是否禁用 */
    disabled: PropTypes.bool,
    /** 当前值（适用于受控组件） */
    value: PropTypes.array,
    /** 默认值 */
    defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    className: PropTypes.string,
    /** 选中状态改变时的回调 function(e, value) */
    onChange: PropTypes.func,
    /** 尺寸 */
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    /** 定制判断值匹配的方法 */
    checkMatching: PropTypes.func,
  };

  static displayName = 'NeatUI.CheckboxGroup';

  static defaultProps = {
    defaultValue: [],
    prefixCls: 'ne-checkbox-group',
    disabled: false,
  };

  constructor(props) {
    super(props);
    this.isControlled = props.value != null;
    if (!this.isControlled) {
      this.state = {
        value: props.defaultValue,
      };
    } else {
      this.state = {};
    }
  }

  componentWillReceiveProps(newProps) {
    if (!this.isControlled && newProps.value != null) {
      this.isControlled = true;
      this.setState({
        value: null,
      });
    }
    if (!this.isControlled && newProps.defaultValue !== this.props.defaultValue) {
      this.setState({
        value: newProps.defaultValue,
      });
    }
  }

  onItemChange = itemValue => e => {
    const { checkMatching, onChange } = this.props;
    let value = this.isControlled ? this.props.value : this.state.value;
    value = Array.isArray(value) ? value : [value];
    const isContained = checkMatching
      ? checkMatching(itemValue, value)
      : value.find(v => itemValue === v);
    if (!isContained) {
      value.push(itemValue);
    } else {
      value.splice(value.indexOf(isContained), 1);
    }
    if (!this.isControlled) {
      this.setState({ value });
    }
    if (onChange) {
      onChange(e, value);
    }
  };

  render() {
    const {
      prefixCls,
      className,
      value: propsValue,
      defaultValue,
      disabled,
      name,
      onChange,
      children,
      error,
      inputProps,
      size,
      matchingCondition,
      status,
      errorIcon,
      loadingIcon,
      successIcon,
      showStatusIcon,
      ...other
    } = this.props;
    let value = this.isControlled ? propsValue : this.state.value;
    value = Array.isArray(value) ? [...value] : [value];
    const items = React.Children.map(children, (child, index) => {
      if (!React.isValidElement(child)) {
        return null;
      }
      const checked = matchingCondition
        ? !!matchingCondition(child.props.value, value)
        : value.indexOf(child.props.value) !== -1;
      return React.cloneElement(child, {
        key: child.props.value || index,
        checked,
        size,
        name: name || child.props.name,
        disabled: disabled || child.props.disabled,
        onChange: this.onItemChange(child.props.value),
      });
    });
    const classes = classNames(
      prefixCls,
      {
        [`${prefixCls}-disabled`]: disabled,
      },
      className,
    );

    return (
      <div className={classes} {...other}>
        {items}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/checkbox/CheckboxGroup.jsx